import { addTag } from '@core';

import { Box } from '../Layout';
import { Heading4 } from '../Text';

const commitSha = import.meta.env['VITE_PUBLIC_GIT_COMMIT_SHA'];

addTag('commitSha', commitSha);

export const CommitSha = () => {
    if (!commitSha) return null;
    return (
        <Box display="flex" justifyContent="center">
            <Heading4 as="p">Version: {commitSha}</Heading4>
        </Box>
    );
};
